import { observer } from "mobx-react-lite";

import { Snackbar } from "@/shared/ui";

import { useStore } from "../../model/RootStoreContext";

const SnackbarProvider = observer(() => {
  const { snackbarStore } = useStore();

  return (
    <Snackbar
      open={snackbarStore.isOpen}
      onClose={() => snackbarStore.close()}
      {...snackbarStore.options}
    />
  );
});

export default SnackbarProvider;
